import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import "react-datepicker/dist/react-datepicker.css";
import axios from "../../axios";
import LinearProgress from "@mui/material/LinearProgress";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  colorPrimary: {
    backgroundColor: "#D3D3D3",
  },
  barColorPrimary: {
    backgroundColor: "#fd8c00",
  },
});



const ClinicalTestDialog = (props) => {
  const classes = useStyles();
  const [state, setState] = useState({
    test_id: "",
    test_name: "RT-PCR",
    test_count: "",
    comments: "",
    cyclicThreshold: "",
    coRads: "",
    ctSeverity: "",
    opinion: "",
    antigen: "no",
    antibody: "no",
    cbc: "",
    hemoglobin: "",
    il6: "",
    dimer: "",
    serum: "",
    ldh: "",
    crp: "",
    lft: "",
    rft: "",
    rbs: "",
    selectedFile: "",
    fvc: "",
    fev: "",
    fev1: "",
    fev1TofvcRation: "",
    uploadPercentage: "",
    mtb: "",
    diseaseCategory: "",
    score: "",
    risk: "",
    sputum: "",
    BLSM: "",
    submitclicked: false,
    labelType: "",
    labelType: false,
    labelTypeRequiredErrorText: false,
  });

  const styles = {
    select: {
      padding: '10px',
      fontSize: '14px',
      border: '1px solid #ccc',
      borderRadius: '5px',
      backgroundColor: '#f9f9f9',
      color: '#333',
       marginTop:'10px',
      width:'200px',
      
    },
    option: {
      padding: '10px',
      backgroundColor: '#ffffff',
      color: '#333',
    }
  };

  const onFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const fileNameParts = file.name.split('.');
      const fileExtension = fileNameParts.pop();
      const newFileName = `${fileNameParts.join('.')}_${state.test_name}.${fileExtension}`; // Append custom text here

      // Create a new File object with the updated file name
      const newFile = new File([file], newFileName, { type: file.type });

      console.log(newFile); // Log the new file with the modified name
      setState({ ...state, selectedFile: newFile });
    }
  };
  const testTypes = [
    {
      name: "RT-PCR",
    },
    {
      name: "HR-CT",
    },
    {
      name: "X-Ray Report",
    },
    {
      name: "X-Ray Film",
    },
    {
      name: "Blood Investigation",
    },
    {
      name: "Antigen",
    },
    {
      name: "Antibody",
    },
    {
      name: "Spirometry",
    },
    {
      name: "CB-NAAT",
    },
    {
      name: "Peak Flow Meter",
    },
    {
      name: "AFB Microscopy",
    },
  ];

  const submitData = () => {
    if (!state.submitclicked) {
      setState({
        ...state,
        submitclicked: true,
        labelTypeRequiredErrorText: true,
      });
    }
    const parameters = [];
    switch (state.test_name) {
      case "RT-PCR":
        parameters.push({
          test_parameter_name: "Cyclic Threshold",
          test_parameter_value: state.cyclicThreshold,
        });
        break;
      case "HR-CT":
        parameters.push({
          test_parameter_name: "Co-RADS Levels",
          test_parameter_value: state.coRads,
        });
        parameters.push({
          test_parameter_name: "CT Severity Index",
          test_parameter_value: state.ctSeverity,
        });
        break;
      case "Peak Flow Meter":
        parameters.push({
          test_parameter_name: "Value",
          test_parameter_value: state.score,
        });
        parameters.push({
          test_parameter_name: "Risk",
          test_parameter_value: state.risk,
        });
        break;
      case "AFB Microscopy":
        parameters.push({
          test_parameter_name: "Sputum",
          test_parameter_value: state.sputum,
        });
        parameters.push({
          test_parameter_name: "Bacillary Load On Sputum Microscopy",
          test_parameter_value: state.BLSM,
        });
        break;

      case "X-Ray Report":
        parameters.push({
          test_parameter_name: "Opinion",
          test_parameter_value: state.opinion,
        });
        break;
      case "X-Ray Film":
        parameters.push({
          test_parameter_name: "Opinion",
          test_parameter_value: state.opinion,
        });
        break;
      case "Blood Investigation":
        parameters.push({
          test_parameter_name: "CBC",
          test_parameter_value: state.cbc,
        });
        parameters.push({
          test_parameter_name: "Hemoglobin",
          test_parameter_value: state.hemoglobin,
        });
        parameters.push({
          test_parameter_name: "IL 6",
          test_parameter_value: state.il6,
        });
        parameters.push({
          test_parameter_name: "D Dimer",
          test_parameter_value: state.dimer,
        });
        parameters.push({
          test_parameter_name: "Serum Ferritin",
          test_parameter_value: state.serum,
        });
        parameters.push({
          test_parameter_name: "LDH",
          test_parameter_value: state.ldh,
        });
        parameters.push({
          test_parameter_name: "CRP",
          test_parameter_value: state.crp,
        });
        parameters.push({
          test_parameter_name: "LFT",
          test_parameter_value: state.lft,
        });
        parameters.push({
          test_parameter_name: "RFT",
          test_parameter_value: state.rft,
        });
        parameters.push({
          test_parameter_name: "RBS",
          test_parameter_value: state.rbs,
        });
        break;
      case "Antigen":
        parameters.push({
          test_parameter_name: "Presence of viral antigen",
          test_parameter_value: state.antigen,
        });
        break;
      case "Antibody":
        parameters.push({
          test_parameter_name: "Presence of antibodies against SARS-CoV-2",
          test_parameter_value: state.antibody,
        });
        break;
      case "Spirometry":
        parameters.push({
          test_parameter_name: "FVC",
          test_parameter_value: state.fvc,
        });
        parameters.push({
          test_parameter_name: "FEV",
          test_parameter_value: state.fev,
        });
        parameters.push({
          test_parameter_name: "FEV1",
          test_parameter_value: state.fev1,
        });
        parameters.push({
          test_parameter_name: "FEV1/FVC",
          test_parameter_value: state.fev1TofvcRation,
        });
        break;
      case "CB-NAAT":
        parameters.push({
          test_parameter_name: "MTB",
          test_parameter_value: state.mtb,
        });
        parameters.push({
          test_parameter_name: "Disease Category",
          test_parameter_value: state.diseaseCategory,
        });
        break;
      default:
        break;
    }

    const userid = props.userId;
    console.log(userid, state.selectedFile);

    if (state.selectedFile !== "" && state.labelTypeRequired) {
      setState({
        ...state,
        labelTypeRequired: false,
        labelTypeRequiredErrorText: false,
      });
      const formData = new FormData();

      formData.append("patientID", userid.toString());
      formData.append("file", state.selectedFile);
      formData.append("doctorId", props.doctorId);
      const options = {
        headers: {
          accessToken: localStorage.accessToken,
        },

        onUploadProgress: (ProgressEvent) => {
          // console.log(ProgressEvent)
          const { loaded, total } = ProgressEvent;
          let percent = Math.floor((loaded * 100) / total);
          // console.log(`${loaded}kb of ${total}kb | ${percent}%`);
          if (percent < 100) {
            setState({ ...state, uploadPercentage: percent });
          }
        },
      };

      // axios({
      //   method: "POST",
      //   url: `/clinicalreport`,
      //   data: formData,
      //   headers: {
      //     accessToken: localStorage.accessToken,
      //   },
      //   onUploadProgress: options
      // })
      axios
        .post("/clinicalreport", formData, options)
        .then((response) => {
          console.log(response.status);
          // setState({ ...state, resportID: response.data.reportID });
          setState({ ...state, uploadPercentage: 100, submitclicked: false });
          const data = {
            test_id: state.test_id,
            test_name: state.test_name,
            test_count: state.test_count,
            comments: state.comments,
            reportID: response?.data?.reportID,
            labelType: state.labelType,
            parameters,
          };
          console.log(data);
          setTimeout(() => {
            setState({ ...state, uploadPercentage: "" });
            props.handleClose(data);
          }, 1200);
        })
        .catch((error) => console.log(error));
    } else {
      const data = {
        test_id: state.test_id,
        test_name: state.test_name,
        test_count: state.test_count,
        comments: state.comments,
        labelType: state.labelType,
        parameters,
      };

      if (state.labelTypeRequired) {
        props.handleClose(data);
        setState({
          ...state,
          submitclicked: false,
          labelTypeRequired: false,
          labelTypeRequiredErrorText: true,
        });
      } else {
        setState({
          ...state,
          submitclicked: false,
          labelTypeRequiredErrorText: true,
        });
      }
    }
  };

  return (
    <Dialog
      disableEscapeKeyDown={true}
      open={props.open}
      onClose={(e, reason) => {
        if (reason !== "backdropClick") {
          props.handleClose(e);
        }
      }}
    >
      <div className="dialog">
        <div className="dialog__header">Add Clinical Test</div>
        <div className="dialog__heading">Test ID</div>
        <input
          className="w-100 input"
          value={state.test_id}
          onChange={(e) => setState({ ...state, test_id: e.target.value })}
        />
        <div className="dialog__heading">Test Name</div>
        <select
          className="w-100 input dialog__select"
          value={state.test_name}
          onChange={(e) => setState({ ...state, test_name: e.target.value })}
        >
          {testTypes.map((type) => (
            <option value={type.name} key={type.name}>
              {type.name}
            </option>
          ))}
        </select>
        <div className="dialog__heading">No of times test performed</div>
        <input
          className="w-100 input"
          value={state.test_count}
          onChange={(e) => setState({ ...state, test_count: e.target.value })}
        />
        {state.test_name === "RT-PCR" && (
          <React.Fragment>
            {" "}
            <div className="dialog__heading">Cyclic Threshold</div>
            <input
              className="w-100 input"
              value={state.cyclicThreshold}
              onChange={(e) =>
                setState({ ...state, cyclicThreshold: e.target.value })
              }
            />
          </React.Fragment>
        )}

        {state.test_name === "Peak Flow Meter" && (
          <React.Fragment>
            <div className="dialog__heading">Value</div>
            <input
              className="w-100 input"
              value={state.score}
              onChange={(e) => setState({ ...state, score: e.target.value })}
            />
            <div className="questions">
              Risk
              <div className="options">
                <RadioGroup
                  row
                  aria-label="Normal"
                  name="Normal"
                  value={state.risk}
                  onChange={(e) => setState({ ...state, risk: e.target.value })}
                >
                  <FormControlLabel
                    value="Normal"
                    control={<Radio />}
                    label="Normal"
                  />
                  <FormControlLabel
                    value="Abnormal"
                    control={<Radio />}
                    label="Abnormal"
                  />
                </RadioGroup>
              </div>
            </div>
          </React.Fragment>
        )}

        {state.test_name === "HR-CT" && (
          <div className="dialog__dates">
            <div className="d-grid">
              <div className="dialog__heading">Co-RADS Levels</div>
              <input
                className="w-100 input"
                value={state.coRads}
                onChange={(e) => setState({ ...state, coRads: e.target.value })}
              />
            </div>
            <div className="d-grid">
              <div className="dialog__heading">CT Severity Index</div>
              <input
                className="w-100 input"
                value={state.ctSeverity}
                onChange={(e) =>
                  setState({ ...state, ctSeverity: e.target.value })
                }
              />
            </div>
          </div>
        )}
        {state.test_name === "X-Ray Report"  && (
          <div className="questions">
            Opinion
            <div className="options">
              <RadioGroup
                row
                aria-label="gender"
                name="opinion"
                value={state.opinion}
                onChange={(e) =>
                  setState({ ...state, opinion: e.target.value })
                }
              >
                <FormControlLabel
                  value="normal"
                  control={<Radio />}
                  label="Normal"
                />
                <FormControlLabel
                  value="abnormal"
                  control={<Radio />}
                  label="Abnormal"
                />
              </RadioGroup>
            </div>
          </div>
        )}
        {state.test_name === "X-Ray Film"  && (
          <div className="questions">
            Opinion
            <div className="options">
              <RadioGroup
                row
                aria-label="gender"
                name="opinion"
                value={state.opinion}
                onChange={(e) =>
                  setState({ ...state, opinion: e.target.value })
                }
              >
                <FormControlLabel
                  value="normal"
                  control={<Radio />}
                  label="Normal"
                />
                <FormControlLabel
                  value="abnormal"
                  control={<Radio />}
                  label="Abnormal"
                />
              </RadioGroup>
            </div>
          </div>
        )}
        {state.test_name === "Blood Investigation" && (
          <div className="dialog__bloodInvestigation">
            <div className="d-grid">
              <div className="dialog__heading">CBC</div>
              <input
                className="w-100 input"
                value={state.cbc}
                onChange={(e) => setState({ ...state, cbc: e.target.value })}
              />
            </div>
            <div className="d-grid">
              <div className="dialog__heading">Hemoglobin</div>
              <input
                className="w-100 input"
                value={state.hemoglobin}
                onChange={(e) =>
                  setState({ ...state, hemoglobin: e.target.value })
                }
              />
            </div>
            <div className="d-grid">
              <div className="dialog__heading">IL 6</div>
              <input
                className="w-100 input"
                value={state.il6}
                onChange={(e) => setState({ ...state, il6: e.target.value })}
              />
            </div>
            <div className="d-grid">
              <div className="dialog__heading">D Dimer</div>
              <input
                className="w-100 input"
                value={state.dimer}
                onChange={(e) => setState({ ...state, dimer: e.target.value })}
              />
            </div>
            <div className="d-grid">
              <div className="dialog__heading">Serum Ferritin</div>
              <input
                className="w-100 input"
                value={state.serum}
                onChange={(e) => setState({ ...state, serum: e.target.value })}
              />
            </div>
            <div className="d-grid">
              <div className="dialog__heading">LDH</div>
              <input
                className="w-100 input"
                value={state.ldh}
                onChange={(e) => setState({ ...state, ldh: e.target.value })}
              />
            </div>
            <div className="d-grid">
              <div className="dialog__heading">CRP</div>
              <input
                className="w-100 input"
                value={state.crp}
                onChange={(e) => setState({ ...state, crp: e.target.value })}
              />
            </div>
            <div className="d-grid">
              <div className="dialog__heading">LFT</div>
              <input
                className="w-100 input"
                value={state.lft}
                onChange={(e) => setState({ ...state, lft: e.target.value })}
              />
            </div>
            <div className="d-grid">
              <div className="dialog__heading">RFT</div>
              <input
                className="w-100 input"
                value={state.rft}
                onChange={(e) => setState({ ...state, rft: e.target.value })}
              />
            </div>
            <div className="d-grid">
              <div className="dialog__heading">RBS</div>
              <input
                className="w-100 input"
                value={state.rbs}
                onChange={(e) => setState({ ...state, rbs: e.target.value })}
              />
            </div>
          </div>
        )}
        {state.test_name === "Spirometry" && (
          <div className="dialog__spirometry">
            <div className="d-grid">
              <div className="dialog__heading">FVC</div>
              <input
                className="w-100 input"
                value={state.fvc}
                onChange={(e) => setState({ ...state, fvc: e.target.value })}
              />
            </div>
            <div className="d-grid">
              <div className="dialog__heading">FEV</div>
              <input
                className="w-100 input"
                value={state.fev}
                onChange={(e) => setState({ ...state, fev: e.target.value })}
              />
            </div>
            <div className="d-grid">
              <div className="dialog__heading">FEV1</div>
              <input
                className="w-100 input"
                value={state.fev1}
                onChange={(e) => setState({ ...state, fev1: e.target.value })}
              />
            </div>
            <div className="d-grid">
              <div className="dialog__heading">FEV1/FVC</div>
              <input
                className="w-100 input"
                value={state.fev1TofvcRation}
                onChange={(e) =>
                  setState({ ...state, fev1TofvcRation: e.target.value })
                }
              />
            </div>
          </div>
        )}
        {state.test_name === "Antigen" && (
          <div className="questions">
            Presence of viral antigen
            <div className="options">
              <RadioGroup
                row
                aria-label="gender"
                name="antigen"
                value={state.antigen}
                onChange={(e) =>
                  setState({ ...state, antigen: e.target.value })
                }
              >
                <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="no" control={<Radio />} label="No" />
              </RadioGroup>
            </div>
          </div>
        )}
        {state.test_name === "Antibody" && (
          <div className="questions">
            Presence of antibodies against SARS-CoV-2
            <div className="options">
              <RadioGroup
                row
                aria-label="gender"
                name="antibody"
                value={state.antibody}
                onChange={(e) =>
                  setState({ ...state, antibody: e.target.value })
                }
              >
                <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="no" control={<Radio />} label="No" />
              </RadioGroup>
            </div>
          </div>
        )}
        {state.test_name === "CB-NAAT" && (
          <React.Fragment>
            <div className="questions">
              MTB
              <div className="options">
                <RadioGroup
                  row
                  aria-label="MTB"
                  name="mtb"
                  value={state.mtb}
                  onChange={(e) => setState({ ...state, mtb: e.target.value })}
                >
                  <FormControlLabel
                    value="Detected"
                    control={<Radio />}
                    label="Detected"
                  />
                  <FormControlLabel
                    value="Not Detected"
                    control={<Radio />}
                    label="Not Detected"
                  />
                </RadioGroup>
              </div>
            </div>
            <div className="questions">
              Disease Category
              <div className="options">
                <RadioGroup
                  row
                  aria-label="Disease Category"
                  name="Disease Category"
                  value={state.diseaseCategory}
                  onChange={(e) =>
                    setState({ ...state, diseaseCategory: e.target.value })
                  }
                >
                  <FormControlLabel
                    value="Drug Sensitive"
                    control={<Radio />}
                    label="Drug Sensitive"
                  />
                  <FormControlLabel
                    value="Drug Resistive"
                    control={<Radio />}
                    label="Drug Resistive"
                  />
                </RadioGroup>
              </div>
            </div>
          </React.Fragment>
        )}
        {state.test_name === "AFB Microscopy" && (
          <React.Fragment>
            <div className="questions">
              Sputum
              <div className="options">
                <RadioGroup
                  row
                  aria-label="Sputum"
                  name="Sputum"
                  value={state.sputum}
                  onChange={(e) =>
                    setState({ ...state, sputum: e.target.value })
                  }
                >
                  <FormControlLabel
                    value="Positive"
                    control={<Radio />}
                    label="Positive"
                  />
                  <FormControlLabel
                    value="Negative"
                    control={<Radio />}
                    label="Negative"
                  />
                </RadioGroup>
              </div>
            </div>
            <div className="questions">
              Bacillary Load On Sputum Microscopy
              <div className="options">
                <select value={state.BLSM} onChange={(e)=>setState({...state, BLSM:e.target.value })} style={styles.select} placeholder="Select">
                  <option value="" disabled selected hidden>Select an option</option>
                  <option value='Scanty' style={styles.option}>Scanty</option>
                  <option value='+1' style={styles.option}>+1</option>
                  <option value='+2' style={styles.option}>+2</option>
                  <option value='+3' style={styles.option}>+3</option>
                </select>
              </div>
            </div>
        
          </React.Fragment>
        )}

        <p className="dialog__heading">Label type *</p>
        <div>
          <RadioGroup
            row
            aria-label="labelType"
            name="labelType"
            value={state.labelType}
            onChange={(e) => {
              setState({
                ...state,
                labelType: e.target.value,
                labelTypeRequired: true,
                labelTypeRequiredErrorText: false,
              });
            }}
          >
            <FormControlLabel
              value="Provisional"
              control={<Radio />}
              label="Provisional"
            />
            <FormControlLabel
              value="Diagnosis"
              control={<Radio />}
              label="Diagnosis"
            />
          </RadioGroup>
        </div>
        {!state.labelTypeRequired && state.labelTypeRequiredErrorText && (
          <p className="label-error">Label type is mandatory*</p>
        )}

        <div className="dialog__heading">Comments</div>
        <input
          className="w-100 input"
          value={state.comments}
          onChange={(e) => setState({ ...state, comments: e.target.value })}
        />
        <div>
          <input type="file" className="fileBox" onChange={onFileChange} />

          {state.uploadPercentage !== "" && (
            <div>
              <LinearProgress
                classes={{
                  colorPrimary: classes.colorPrimary,
                  barColorPrimary: classes.barColorPrimary,
                }}
                variant="determinate"
                value={state.uploadPercentage}
              />
              {state.uploadPercentage} % uploaded
            </div>
          )}
        </div>
        <div className="d-grid buttons justify-content-around">
          <button
            className="btn secondary-button"
            onClick={() => props.handleClose("cancel")}
          >
            Cancel
          </button>
          <button className="btn primary-button" onClick={submitData}>
            Submit
          </button>
        </div>
      </div>
    </Dialog>
  );
};

export default ClinicalTestDialog;
